var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe-form-wrapper",style:(_vm.iframeHeightComputedStyle),attrs:{"src":_vm.iframeSrc,"frameborder":"0","scrolling":_vm.iframeHeight ? 'no' : 'yes'}})
}
var staticRenderFns = []

export { render, staticRenderFns }